import { useEffect } from "react";
import { useState } from "react";
import useExamRoomActions from "../../../../api/hooks/admin/examRoom";
import Modal from "../../../modules/layout/Modal";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const DeleteConfirmModal = ({ deleteUserSn, setDeleteUserSn, isCandidate }) => {
  const { deleteReceipt, deleteTester } = useExamRoomActions();
  const queryClient = useQueryClient();
  const [isDeleteConfirmModalOpen, setIsDeleteConfirmModalOpen] =
    useState(false);
  const [pw, setPw] = useState("");

  useEffect(() => {
    if (deleteUserSn) {
      setIsDeleteConfirmModalOpen(true);
      // console.log("유즈 이펙트", deleteUserSn, pw, isCandidate);
    }
  }, [deleteUserSn]);

  const delApplicant = useMutation(deleteReceipt, {
    onSuccess: (context) => {
      queryClient.invalidateQueries(["fetchReceiptList"]);
      setIsDeleteConfirmModalOpen(false);
      alert("삭제완료");
    },
    onError: () => {
      alert("삭제실패.");
    },
  });

  const delCandidate = useMutation(deleteTester, {
    onSuccess: (context) => {
      queryClient.invalidateQueries(["fetchReceiptList"]);
      setIsDeleteConfirmModalOpen(false);
      alert("삭제완료");
    },
    onError: () => {
      alert("삭제실패.");
    },
  });

  return (
    <Modal isOpen={isDeleteConfirmModalOpen}>
      <div style={{ display: "block" }} className="modal fade" id="delete">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header flex">
              <p className="sign-top-title" id="staticBackdropLabel"></p>
              <button
                type="button"
                className="close"
                onClick={() => {
                  setDeleteUserSn(0);
                  setIsDeleteConfirmModalOpen(false);
                }}
              ></button>
            </div>
            <div className="modal-body confirm-sec">
              <div className="modal-title">
                <p>작업수행 확인</p>
              </div>
              <div className="modal-cont">
                <div className="info-sec">
                  <p className="info-sec-title">비밀번호</p>
                  <input
                    type="text"
                    className="info-input"
                    placeholder="비밀번호를 입력하세요"
                    onChange={(e) => {
                      setPw(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="delete-warning text-align-center">
                <p>
                  작업수행 확인: 비밀번호 입력 후 '확인'시 요청한 작업이
                  실행됩니다.
                </p>
                <p>(1)응시요청, (2)응시결과, (3)응시자 계정 모두 삭제됩니다.</p>
              </div>
              <div className="modal-footer text-align-right">
                <button
                  type="button"
                  className="modal-btn modal-close-btn"
                  onClick={() => {
                    setDeleteUserSn(0);
                    setIsDeleteConfirmModalOpen(false);
                  }}
                >
                  취소
                </button>
                <button
                  type="button"
                  className="modal-btn modal-save-btn"
                  onClick={() => {
                    // console.log("확인", deleteUserSn, pw, isCandidate);
                    if (isCandidate === true) {
                      // console.log("응시자탭");
                      delCandidate.mutate({
                        tester_sn: deleteUserSn,
                        pw: pw,
                      });
                    } else {
                      // console.log("신청자탭");
                      delApplicant.mutate({
                        applicator_sn: deleteUserSn,
                        pw: pw,
                      });
                    }
                  }}
                >
                  확인
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
